<div class="spa-navbar-container">
  <div class="spa-navbar">
    <ul class="spa-navbar__nav" data-testid="main_navbar">
      @for (route of filteredRoutes(); track route) {
        <li class="spa-navbar__nav-item" [attr.data-testid]="'main_navbar_item--' + [route.path]">
          <a
            class="spa-navbar__nav-link {{ route.path }}"
            routerLinkActive="active"
            [routerLink]="[route.path]"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <spa-icon fontSize="40px" shape="outlined">{{ itemIcons[route.path] }}</spa-icon>
          </a>
        </li>
      }
    </ul>
  </div>
</div>
